import React, { useEffect, useState } from 'react'
import { View, Text, StyleSheet, Image, TouchableOpacity } from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import StyledText from '../../../StyledText'
import theme from '../../../theme'
import CalculateDate from '../customUtils/calculateDates/calculateDates'
import { getImageStogeUrl } from '../imageUploader/ImageStorage'
import { getAvatarFromCache, setAvatarInCache } from '../../utils/ttlCache'
import { apiUrl } from '../../config/config'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'
import styles from './ModalCommentsStyles'
import app from '../../../app.config'
import { avatarPlaceholder } from '../customUtils/Constants'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { FlatList } from 'react-native-gesture-handler'
import { Platform } from 'react-native'
let BottomSheetFlatList
if (Platform.OS !== 'web') {
    const bottomSheet = require('@gorhom/bottom-sheet')
    BottomSheetFlatList = bottomSheet.BottomSheetFlatList
}

// Cache simple de URLs ya resueltas para Avatars en comentarios
const __commentsAvatarCache = new Map()

const CommentsComponent = ({ comment, onReply, handleLike, inputRef, replies_response, comment_id }) => {
    // Render function for replies in BottomSheetFlatList
    const renderComment = ({ item }) => <ReplysView key={item._id} reply={item} handleLikeComment={(id) => handleLikeComment(id, comment._id)} />
    const [showAllReplies, setShowAllReplies] = useState(comment_id ? comment._id.toString() === comment_id.toString() : false)

    const [avatar, setAvatarUrl] = useState(avatarPlaceholder)
    const [page, setPage] = useState(0)
    const [size, setSize] = useState(2)
    const [replies, setReplies] = useState([])
    const [countReplies, setCountReplies] = useState(null)
    const [totalValue, setTotalValue] = useState(0)
    let totalRep = totalValue - replies.length

    const handleToggleReplies = async () => {
        if (replies.length == 0) {
            await fetchReplies(0)
        }
        setShowAllReplies(!showAllReplies)
    }

    const handleReply = (user_name, commentId) => {
        inputRef.current.focus() // al tocar el boton responder, abro el teclado
        onReply(user_name, commentId)
    }

    const { languageFile } = getLanguage()

    useEffect(() => {
        let mounted = true
        const key = comment?.avatar_image
        const hit = key ? __commentsAvatarCache.get(key) : null
        if (hit) {
            setAvatarUrl(hit)
            return
        }
        if (key) {
            // 1) TTL cache persistente
            getAvatarFromCache(key)
                .then((cached) => {
                    if (!mounted) return
                    if (cached) {
                        __commentsAvatarCache.set(key, cached)
                        setAvatarUrl(cached)
                        return true
                    }
                    return false
                })
                .then((servedFromCache) => {
                    if (servedFromCache) return
                    // 2) Resolver si no hubo hit
                    getImageStogeUrl(key)
                        .then(async (url) => {
                            if (!mounted) return
                            if (url) {
                                __commentsAvatarCache.set(key, url)
                                setAvatarUrl(url)
                                try {
                                    await setAvatarInCache(key, url)
                                } catch {}
                            }
                        })
                        .catch(() => {})
                })
                .catch(() => {})
        }
        return () => {
            mounted = false
        }
    }, [comment])

    const handleLikeComment = async (commentId, father_id) => {
        // Optimismo para respuestas (cuando father_id no es null)
        let rollback = null
        if (father_id && replies.length > 0) {
            setReplies((prev) => {
                let changed = false
                const next = prev.map((rep) => {
                    if (rep._id.toString() === commentId.toString()) {
                        const prevSel = !!rep.isSelected
                        const prevCount = Number(rep.likes_count) || 0
                        const nextSel = !prevSel
                        const nextCount = Math.max(0, prevCount + (nextSel ? 1 : -1))
                        rollback = { _id: rep._id, isSelected: prevSel, likes_count: prevCount }
                        changed = true
                        return { ...rep, isSelected: nextSel, likes_count: nextCount }
                    }
                    return rep
                })
                return changed ? next : prev
            })
        }

        let response_like = await handleLike(commentId, father_id)
        if (father_id && replies.length > 0 && response_like) {
            if (response_like.status === 1) {
                let dataResponse = response_like.single || {}
                const updatedReplies = replies.map((rep) => {
                    if (rep._id.toString() === dataResponse?.comment.toString()) {
                        return {
                            ...rep,
                            isSelected: dataResponse.status_like,
                            likes_count: dataResponse.counter,
                        }
                    }
                    return rep
                })
                setReplies(updatedReplies)
            } else if (rollback) {
                // Revertir optimismo
                setReplies((prev) =>
                    prev.map((rep) =>
                        rep._id.toString() === rollback._id.toString()
                            ? { ...rep, isSelected: rollback.isSelected, likes_count: rollback.likes_count }
                            : rep,
                    ),
                )
            }
        }
    }

    const fetchReplies = async (fetchPage) => {
        try {
            const authToken = await getAuthToken()
            if (!authToken) return
            const headers = {
                'Content-Type': 'application/json',
                Authorization: authToken,
                comment_id: comment._id,
            }

            if (String(comment._id).startsWith('temp_')) {
                throw new Error(`[ModalComments] Cannot reply to optimistic comment: ${comment._id}`)
            }

            const response = await fetch(`${apiUrl}/get_child_comments?page=${fetchPage}&size=${size}`, {
                method: 'GET',
                headers: headers,
            })

            if (!response.ok) {
                const errorResponse = await response.json()
                throw new Error(`Fallo al agregar el comentario. Código de estado: ${response.status}. Detalles: ${JSON.stringify(errorResponse)}`)
            }

            const data = await response.json()

            let prevRep = 0
            if (data.status == 1) {
                if (data.single?.comments.length > 0) {
                    const updatedComments = await Promise.all(
                        data.single?.comments.map(async (element) => {
                            const k = element.avatar_image
                            const hit = k ? __commentsAvatarCache.get(k) : null
                            if (hit) return { ...element, avatar_image: hit }
                            try {
                                const cached = await getAvatarFromCache(k)
                                if (cached) {
                                    __commentsAvatarCache.set(k, cached)
                                    return { ...element, avatar_image: cached }
                                }
                                const url = await getImageStogeUrl(k)
                                if (url) {
                                    __commentsAvatarCache.set(k, url)
                                    try {
                                        await setAvatarInCache(k, url)
                                    } catch {}
                                }
                                return { ...element, avatar_image: url || k }
                            } catch {
                                return { ...element }
                            }
                        }),
                    )
                    setReplies((prevState) => [...prevState, ...updatedComments])
                    prevRep = replies.length + updatedComments.length
                    // Actualizar el número total de respuestas restantes
                }
                if (data?.single?.length != 0) {
                    // const remainingReplies = data.single.count - (page ) * size
                    setCountReplies(data?.single?.count - prevRep)
                    setTotalValue(data?.single?.count)
                    console.log('Entro aca?')
                } else {
                    setCountReplies(0)
                }
            }
        } catch (error) {
            console.error('Error al obtener las respuestas:', error)
        }
    }

    const loadMoreReplies = () => {
        console.log('Entro al load')
        fetchReplies(page + 1)
        setPage(page + 1)
    }

    // useEffect(() => {
    //     if (comment.replies_counter > 0) {
    //         fetchReplies()
    //     }
    // }, [page])

    useEffect(() => {
        if (replies_response.length > 0 && replies_response[0]['comment_id'].toString() == comment._id.toString()) {
            setPage(0)
            setReplies([])

            //TODO: NO EXISTE EN optimisticComment
            // comment.replies_counter = replies_response[0]['comments'].length // Esto cuenta la cantidad de caracteres que tiene el string ?
            comment.replies_counter = replies_response.length
            setCountReplies(comment.replies_counter)

            //  setReplies(replies_response[0]['comments'])

            fetchReplies(0)
        }
    }, [replies_response])

    return (
        <>
            <View style={styles.comments}>
                <View style={styles.avatarContainer}>
                    {(() => {
                        let avatarSource
                        if (typeof avatar === 'number') {
                            // require('...')
                            avatarSource = avatar
                        } else if (avatar && typeof avatar === 'object' && typeof avatar.uri === 'string') {
                            avatarSource = { uri: avatar.uri || avatarPlaceholder }
                        } else if (typeof avatar === 'string') {
                            avatarSource = { uri: avatar || avatarPlaceholder }
                        } else {
                            avatarSource = { uri: avatarPlaceholder }
                        }
                        return <Image style={styles.avatar} source={avatarSource} />
                    })()}
                </View>
                <View style={styles.commentsContent}>
                    <View style={styles.commentsBlockBottom}>
                        <View style={styles.commentHeader}>
                            <StyledText fontWeight='bold' fontSize='normalText'>
                                {comment.name
                                    ? comment?.name.length < 21 && comment?.name != comment?.name.toUpperCase()
                                        ? comment?.name
                                        : comment?.name === comment?.name.toUpperCase()
                                        ? comment?.name.substring(0, 11) + '...'
                                        : comment?.name.substring(0, 20) + '...'
                                    : 'Usuario'}
                            </StyledText>
                            <StyledText fontSize='smallText' color='textSecondary'>
                                {CalculateDate(comment?.created_date)}
                            </StyledText>
                        </View>

                        <View>
                            <StyledText fontWeight='normal' fontSize='normalText'>
                                {comment?.comment}
                            </StyledText>
                        </View>

                        <View style={styles.commentFooter}>
                            {comment?.replies_counter > 0 && !showAllReplies && (
                                <TouchableOpacity onPress={() => handleToggleReplies()}>
                                    <StyledText fontWeight='normal' fontSize='smallText' color='textSecondary'>
                                        {!showAllReplies && (
                                            <>
                                                {languageFile.see}
                                                {comment.replies_counter}
                                                {languageFile.answers} ·
                                            </>
                                        )}
                                    </StyledText>
                                </TouchableOpacity>
                            )}

                            <TouchableOpacity onPress={() => handleReply(`@${comment.name ?? ''} `, comment._id)}>
                                <StyledText fontWeight='bold' fontSize='smallText' color={'textSecondary'}>
                                    {languageFile.reply}
                                </StyledText>
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View style={styles.commentsLikeCuore}>
                        <TouchableOpacity onPress={() => handleLikeComment(comment._id, null)}>
                            <Ionicons
                                name={(comment ? comment.isSelected : false) ? 'heart-sharp' : 'heart-outline'}
                                size={18}
                                color={(comment ? comment.isSelected : false) ? theme.colors.colorTertiary : theme.colors.colorTertiary}
                                style={styles.iconPosts}
                            />
                            <View style={{ height: 4 }}></View>
                            <StyledText fontWeight='normal' fontSize='ultraSmallText' style={styles.likesCount}>
                                {comment?.likes_count}
                            </StyledText>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>

            {showAllReplies &&
                replies &&
                replies.map((reply) => <ReplysView key={reply._id} reply={reply} handleLikeComment={(id) => handleLikeComment(id, comment._id)} />)}

            {totalRep > 0 && showAllReplies && countReplies ? (
                <TouchableOpacity onPress={() => loadMoreReplies()} style={styles.see}>
                    <StyledText fontWeight='normal' fontSize='smallText' color={'textSecondary'}>
                        {languageFile.see + totalRep + ' ' + languageFile.more_answers}
                    </StyledText>
                </TouchableOpacity>
            ) : (
                showAllReplies && (
                    <TouchableOpacity onPress={handleToggleReplies} style={styles.hide}>
                        <StyledText fontWeight='normal' fontSize='smallText' color={'textSecondary'}>
                            {languageFile.hide}
                            {comment.replies_counter}
                            {languageFile.answers}
                        </StyledText>
                    </TouchableOpacity>
                )
            )}
        </>
    )
}

export default CommentsComponent

export const ReplysView = ({ reply, handleLikeComment }) => {
    const [avatar] = useState(reply?.avatar_image ?? avatarPlaceholder)

    return (
        <View style={styles.reply}>
            <View style={styles.replyAvatarContainer}>
                {(() => {
                    let replySource
                    if (typeof avatar === 'number') {
                        replySource = avatar
                    } else if (avatar && typeof avatar === 'object' && typeof avatar.uri === 'string') {
                        replySource = { uri: avatar.uri || avatarPlaceholder }
                    } else if (typeof avatar === 'string') {
                        replySource = { uri: avatar || avatarPlaceholder }
                    } else {
                        replySource = { uri: avatarPlaceholder }
                    }
                    return <Image style={styles.replyAvatar} source={replySource} />
                })()}
            </View>
            <View style={styles.replyContent}>
                <View style={styles.commentHeader}>
                    <StyledText fontWeight='bold' fontSize='normalText' color='textPrimary'>
                        {reply?.name}
                    </StyledText>
                    <StyledText fontSize='smallText' color='textSecondary'>
                        {CalculateDate(reply?.created_date)}
                    </StyledText>
                </View>
                <StyledText fontWeight='normal' fontSize='normalText' color='textPrimary'>
                    {reply?.comment}
                </StyledText>
            </View>

            <View style={styles.answerLikeCuore}>
                <TouchableOpacity onPress={() => handleLikeComment(reply._id)}>
                    {/* <Ionicons name='heart-outline' size={20} color={theme.colors.colorTertiary} /> */}
                    <Ionicons
                        name={(reply ? reply.isSelected : false) ? 'heart-sharp' : 'heart-outline'}
                        size={18}
                        color={(reply ? reply.isSelected : false) ? theme.colors.colorTertiary : theme.colors.colorTertiary}
                        style={styles.iconPosts}
                    />
                    <View style={{ height: 4 }}></View>
                    <StyledText fontWeight='normal' fontSize='ultraSmallText' style={styles.likesCount}>
                        {reply?.likes_count}
                    </StyledText>
                </TouchableOpacity>
            </View>
        </View>
    )
}
